import { ButtonPanel, IActionsProps } from 'components/Dialogs/ButtonPanel';
import { useTabbingContext } from 'contexts/TabbingContext';
// import './PropertyGridButtons.less'

export interface IPropertyGridButtonsProps {
  okActionName?: string;
  showLoadFromDataButton?: boolean;
  hasChildren?: boolean;
  cancelActionName?: string;
  onOk?: () => void;
  onCancel?: () => void;
  onLoadData?: () => void;
  disableSave?: boolean;
}

/**
 * Property Grid Buttons. Since dialog itself is legacy, relying on legacy dialog buttons for now.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function PropertyGridButtons({
  cancelActionName,
  disableSave,
  hasChildren,
  okActionName,
  onCancel,
  onLoadData,
  onOk,
  showLoadFromDataButton,
}: IPropertyGridButtonsProps) {
  const tabIndex = useTabbingContext();

  const actions: IActionsProps[] = [];

  if (showLoadFromDataButton && hasChildren) {
    actions.push({
      name: "Load From XML/JSON",
      onClick: onLoadData,
      tabIndex,
    })
  }

  if (cancelActionName) {
    actions.push({
      name: cancelActionName,
      onClick: onCancel,
      tabIndex,
    })
  }

  actions.push({ name: okActionName || 'Ok', onClick: onOk, isDisabled: disableSave, tabIndex });

  return <ButtonPanel actions={actions} disablePadding />;
}
